import { ILogUserData } from 'schemas';
import { ELogType } from 'types';

import { INormaliseUserProps } from '../interfaces';

export const getLogObject = ({
  type,
  client,
  worker,
}: INormaliseUserProps): ILogUserData | null => {
  switch (type) {
    case ELogType.BONUS_PAYMENT_CREATED:
    case ELogType.BONUS_UPDATED:
    case ELogType.BOOKING_CANCELED:
    case ELogType.BOOKING_CREATED:
    case ELogType.BOOKING_FAILED_TO_START:
    case ELogType.DEBT_ACTIVATED:
    case ELogType.DEPOSIT_UPDATED:
    case ELogType.HOST_ADMIN_CALL_CHECKED:
    case ELogType.HOST_ADMIN_CALL_FAILED:
    case ELogType.HOST_PUNISHED:
    case ELogType.USER_RESET_PASSWORD:
    case ELogType.USER_DISCOUNT_UPDATED:
    case ELogType.USER_CHANGED_GROUP:
    case ELogType.USER_BANNED:
    case ELogType.PAYMENT_REFUND:
    case ELogType.PAYMENT_CREATED:
      return client;
    case ELogType.HOST_ADMIN_CALLED:
    case ELogType.WORKER_UPDATED:
    case ELogType.WORKER_ENABLED:
    case ELogType.WORKER_DELETED:
    case ELogType.WORKER_CREATED:
    case ELogType.TASK_ADDED:
      return worker;
    default:
      return null;
  }
};
